import Gradient from "components/Gradient"
import Lightbox from "components/common/Lightbox"
import Toast from "components/common/Toast"
import LoadingContainer from "modules/loader-watchers/LoadingContainer"
import ConfirmModal from "modules/modals/ConfirmModal"
import ShareModal from "modules/modals/ShareModal"
import { useEffect } from "react"
import { RouterProvider } from "react-router-dom"
import { router } from "router"

import { useDisablePinchZoom } from "hooks/useDisablePinchZoom"
import { dateTime } from "modules/datepicker/helpers"
import { useBreakpoints } from "modules/window/hooks/useBreakpoints"

import useAssume from "hooks/useAssume"

import "antd/dist/reset.css"
import "react-lazy-load-image-component/src/effects/blur.css"
import "stylesheets/application.scss"
import "stylesheets/bootstrap.scss"
import "stylesheets/index.css"
// import 'antd/dist/antd.css'
import { AntdThemeProvider } from "context/AntdThemeContext"
import { useSelector } from "react-redux"
import ThemeProvider from "./context/ThemeProvider"

global.dateTime = dateTime

function App() {
  useAssume()
  useBreakpoints()
  useDisablePinchZoom()

  // Update favicon if user is Sportswoman
  const isSportsman = useSelector((state) => state.user.is_sportsman)

  const updateFavicon = (isSportsman) => {
    const favicons = document.querySelectorAll("link[rel~='icon']")

    favicons.forEach((favicon) => {
      const prefix = isSportsman ? "new-" : "sportswoman-"
      if (favicon.sizes.value === "192x192") {
        favicon.href = `/new-favicon/${prefix}android-chrome-192x192.png`
      } else if (favicon.sizes.value === "32x32") {
        favicon.href = `/new-favicon/${prefix}favicon-32x32.png`
      } else if (favicon.sizes.value === "16x16") {
        favicon.href = `/new-favicon/${prefix}favicon-16x16.png`
      }
    })
  }

  useEffect(() => {
    updateFavicon(isSportsman)
  }, [isSportsman])

  return (
    <AntdThemeProvider>
      <ThemeProvider>
        <Gradient />
        <Toast />
        <Lightbox />
        <ConfirmModal />
        <ShareModal />
        <LoadingContainer spinnerProps={{ position: "fixed" }}>
          <RouterProvider router={router} />
        </LoadingContainer>
      </ThemeProvider>
    </AntdThemeProvider>
  )
}

export default App
